import { create } from 'zustand'
import type { Unlock } from '@/lib/achieve'

/** Полученные достижения, о которых ещё не показали карточку: по одной, по порядку. */
interface AchievementsState {
  queue: Unlock[]
  push: (u: Unlock) => void
  dismiss: () => void
}

export const useAchievementsStore = create<AchievementsState>((set) => ({
  queue: [],
  push: (u) => set((s) => (s.queue.some((q) => q.id === u.id) ? s : { queue: [...s.queue, u] })),
  dismiss: () => set((s) => ({ queue: s.queue.slice(1) })),
}))
